import { render, staticRenderFns } from "./unionVideoDetail.vue?vue&type=template&id=a87f5556&scoped=true"
import script from "./unionVideoDetail.vue?vue&type=script&lang=js"
export * from "./unionVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./unionVideoDetail.vue?vue&type=style&index=0&id=a87f5556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87f5556",
  null
  
)

export default component.exports